import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { isRTL } from '../i18n'

interface DirectionProviderProps {
  children: React.ReactNode
}

/**
 * Provider component that manages document direction based on language
 */
export const DirectionProvider: React.FC<DirectionProviderProps> = ({
  children,
}) => {
  const { i18n } = useTranslation()

  useEffect(() => {
    const updateDirection = (lng: string) => {
      const direction = isRTL(lng) ? 'rtl' : 'ltr'
      document.documentElement.dir = direction
      document.documentElement.lang = lng

      if (isRTL(lng)) {
        document.body.classList.add('rtl')
      } else {
        document.body.classList.remove('rtl')
      }
    }

    // Set initial direction
    updateDirection(i18n.language)

    // Listen for language changes
    i18n.on('languageChanged', updateDirection)

    return () => {
      i18n.off('languageChanged', updateDirection)
    }
  }, [i18n])

  return <>{children}</>
}
